import { Module } from '../../ts/Module';
import { IExtensionsSettingsCtrlScope, SiteSettingsForExtensionsCtrl } from '../controllers/SiteSettingsForExtensionsCtrl';

Module.instance().directive('tbSiteSettingsForExtensionsForm',
  () => {
    return {
      restrict: 'E',
      replace: true,
      require: '^?tbSettingsCoordinator',
      templateUrl: 'siteSettingsForExtensionsForm.html',
      link: ($scope: IExtensionsSettingsCtrlScope,
        elm: JQuery,
        attrs: ng.IAttributes) => {
       $scope.localForm.formController = $scope.localForm.formController;
       $scope.sharedForm.registerFormStateByName($scope.localForm, 'extensionsSettingsForm');

      },
      controller: SiteSettingsForExtensionsCtrl
    };
  }
);
